import { titleCase } from "../../../helper";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";

interface Props {
  additionalFacility: {
    facilities: string,
    remarks: string
  }[];
}

const AdditionalService = ({ additionalFacility }: Props) => {
  return (
    <BoxTab>
      {additionalFacility.map((facility) => (
        <BoxTabEach>
          <TabHeader>{titleCase(facility.remarks)}</TabHeader>
          <TabSub>{facility.facilities}</TabSub>
        </BoxTabEach>
      ))}
    </BoxTab>
  );
};

export default AdditionalService;
